import { useCurrentAccount } from "@/features/accounts/hooks/useCurrentAccount";
import { ChevronLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { AnimalTimeline } from "../components/AnimalTimeline";

export function AnimalTimelinePage() {
  const { animalId = "" } = useParams<{ animalId: string }>();
  const { currentAccount } = useCurrentAccount();
  const accountId = currentAccount?.id ?? "";

  return (
    <>
      <title>Línea de tiempo · Hato · HATO</title>
      <Breadcrumb animalId={animalId} />
      <div className="mt-4">
        <header className="mb-4">
          <h1 className="font-semibold text-[18px] text-app-ink-1">Línea de tiempo</h1>
          <p className="mt-0.5 text-[13px] text-app-ink-3">
            Eventos del animal en orden cronológico.
          </p>
        </header>

        {accountId && animalId && <AnimalTimeline accountId={accountId} animalId={animalId} />}
      </div>
    </>
  );
}

function Breadcrumb({ animalId }: { animalId: string }) {
  return (
    <nav aria-label="Migas de pan" className="flex items-center gap-2 text-[12px] text-app-ink-3">
      <Link to="/app/hato" className="inline-flex items-center gap-1 hover:text-app-ink-1">
        <ChevronLeft className="h-3.5 w-3.5" aria-hidden />
        <span>Hato</span>
      </Link>
      <span aria-hidden>›</span>
      <Link to={`/app/hato/${animalId}`} className="hover:text-app-ink-1">
        Detalle
      </Link>
      <span aria-hidden>›</span>
      <span className="text-app-ink-2">Línea de tiempo</span>
    </nav>
  );
}
